import type { Product } from '../types';

export const parsedProducts: Product[] = [
  {
    "id": "prod-ky-015-dht11-temperature-and-humidity-sensor-module",
    "name": "KY-015 DHT11 Temperature and Humidity Sensor Module",
    "categoryId": "sensors",
    "subCategoryId": "temp-humidity",
    "shortDescription": "High quality KY-015 DHT11 Temperature and Humidity Sensor Module for hobbyists and professionals.",
    "longDescription": "The KY-015 DHT11 Temperature and Humidity Sensor Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 230,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-dht22-digital-temperature-humidity-sensor-module-with-cable-not-original-asair",
    "name": "DHT22 Digital Temperature & Humidity Sensor Module (with Cable - not Original ASAIR)",
    "categoryId": "sensors",
    "subCategoryId": "temp-humidity",
    "shortDescription": "High quality DHT22 Digital Temperature & Humidity Sensor Module (with Cable - not Original ASAIR) for hobbyists and professionals.",
    "longDescription": "The DHT22 Digital Temperature & Humidity Sensor Module (with Cable - not Original ASAIR) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 530,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-ky-001-ds18b20-temperature-sensor-module",
    "name": "KY-001 DS18B20 Temperature Sensor Module",
    "categoryId": "sensors",
    "subCategoryId": "temp-humidity",
    "shortDescription": "High quality KY-001 DS18B20 Temperature Sensor Module for hobbyists and professionals.",
    "longDescription": "The KY-001 DS18B20 Temperature Sensor Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 270,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-unsoldered-gy-bme280-3-3v-precision-altimeter-atmospheric-pressure-sensor-module",
    "name": "Unsoldered GY-BME280-3.3V Precision Altimeter Atmospheric Pressure Sensor Module",
    "categoryId": "sensors",
    "subCategoryId": "temp-humidity",
    "shortDescription": "High quality Unsoldered GY-BME280-3.3V Precision Altimeter Atmospheric Pressure Sensor Module for hobbyists and professionals.",
    "longDescription": "The Unsoldered GY-BME280-3.3V Precision Altimeter Atmospheric Pressure Sensor Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1630,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-5v-hc-sr04-ultrasonic-sensor-4pin",
    "name": "5V HC-SR04 Ultrasonic Sensor 4pin",
    "categoryId": "sensors",
    "subCategoryId": "motion-distance",
    "shortDescription": "High quality 5V HC-SR04 Ultrasonic Sensor 4pin for hobbyists and professionals.",
    "longDescription": "The 5V HC-SR04 Ultrasonic Sensor 4pin is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 310,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1581092334651-ddf1a89a2440?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-ir-obstacle-sensor-tcrt5000-ky-033-tracking-module",
    "name": "IR Obstacle Sensor (TCRT5000)/KY-033 Tracking Module",
    "categoryId": "sensors",
    "subCategoryId": "motion-distance",
    "shortDescription": "High quality IR Obstacle Sensor (TCRT5000)/KY-033 Tracking Module for hobbyists and professionals.",
    "longDescription": "The IR Obstacle Sensor (TCRT5000)/KY-033 Tracking Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 160,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1581092334651-ddf1a89a2440?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-mpu-6050-module-gy-521-3-axis-acceleration-gyroscope-6-dof-module",
    "name": "MPU-6050 Module GY-521 3 Axis Acceleration Gyroscope 6 DOF Module",
    "categoryId": "sensors",
    "subCategoryId": "motion-distance",
    "shortDescription": "High quality MPU-6050 Module GY-521 3 Axis Acceleration Gyroscope 6 DOF Module for hobbyists and professionals.",
    "longDescription": "The MPU-6050 Module GY-521 3 Axis Acceleration Gyroscope 6 DOF Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 900,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1581092334651-ddf1a89a2440?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-unsoldered-gy-61-adxl335-3-axis-accelerometer-tilt-angle-module",
    "name": "Unsoldered GY-61 ADXL335 3-axis Accelerometer Tilt Angle Module",
    "categoryId": "sensors",
    "subCategoryId": "motion-distance",
    "shortDescription": "High quality Unsoldered GY-61 ADXL335 3-axis Accelerometer Tilt Angle Module for hobbyists and professionals.",
    "longDescription": "The Unsoldered GY-61 ADXL335 3-axis Accelerometer Tilt Angle Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 2110,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1581092334651-ddf1a89a2440?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-capacitive-soil-moisture-sensor-v1-2",
    "name": "Capacitive Soil Moisture Sensor V1.2",
    "categoryId": "sensors",
    "subCategoryId": "soil-water",
    "shortDescription": "High quality Capacitive Soil Moisture Sensor V1.2 for hobbyists and professionals.",
    "longDescription": "The Capacitive Soil Moisture Sensor V1.2 is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 240,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-raindrops-detection-sensor-module-snow-rain-weather",
    "name": "Raindrops Detection Sensor Module Snow Rain Weather",
    "categoryId": "sensors",
    "subCategoryId": "soil-water",
    "shortDescription": "High quality Raindrops Detection Sensor Module Snow Rain Weather for hobbyists and professionals.",
    "longDescription": "The Raindrops Detection Sensor Module Snow Rain Weather is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 270,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-mq-2-smoke-gas-lpg-butane-hydrogen-sensor-module",
    "name": "MQ-2 Smoke Gas LPG Butane Hydrogen Sensor Module",
    "categoryId": "sensors",
    "subCategoryId": "gas-chemical",
    "shortDescription": "High quality MQ-2 Smoke Gas LPG Butane Hydrogen Sensor Module for hobbyists and professionals.",
    "longDescription": "The MQ-2 Smoke Gas LPG Butane Hydrogen Sensor Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 400,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-mq-135-air-quality-sensor-detection-module",
    "name": "MQ-135 Air Quality Sensor Detection Module",
    "categoryId": "sensors",
    "subCategoryId": "gas-chemical",
    "shortDescription": "High quality MQ-135 Air Quality Sensor Detection Module for hobbyists and professionals.",
    "longDescription": "The MQ-135 Air Quality Sensor Detection Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 490,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-hc-sr501-pir-motion-sensor-module-green",
    "name": "HC-SR501 PIR Motion Sensor Module Green",
    "categoryId": "sensors",
    "subCategoryId": "motion-distance",
    "shortDescription": "High quality HC-SR501 PIR Motion Sensor Module Green for hobbyists and professionals.",
    "longDescription": "The HC-SR501 PIR Motion Sensor Module Green is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 270,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1581092334651-ddf1a89a2440?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-rain-water-level-detection-sensor-module",
    "name": "Rain Water Level Detection Sensor Module",
    "categoryId": "sensors",
    "subCategoryId": "soil-water",
    "shortDescription": "High quality Rain Water Level Detection Sensor Module for hobbyists and professionals.",
    "longDescription": "The Rain Water Level Detection Sensor Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 110,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-water-flow-sensor-sea-zj-s201-flowmeter-g1-2-1-30l-min-white-5-24v",
    "name": "Water Flow Sensor (Sea) ZJ-S201 Flowmeter G1/2 1-30L/min White 5-24V",
    "categoryId": "sensors",
    "subCategoryId": "soil-water",
    "shortDescription": "High quality Water Flow Sensor (Sea) ZJ-S201 Flowmeter G1/2 1-30L/min White 5-24V for hobbyists and professionals.",
    "longDescription": "The Water Flow Sensor (Sea) ZJ-S201 Flowmeter G1/2 1-30L/min White 5-24V is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 760,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-bmp180-digital-barometric-pressure-sensor-module-high-quality",
    "name": "BMP180 Digital Barometric Pressure Sensor Module High Quality",
    "categoryId": "sensors",
    "subCategoryId": "temp-humidity",
    "shortDescription": "High quality BMP180 Digital Barometric Pressure Sensor Module High Quality for hobbyists and professionals.",
    "longDescription": "The BMP180 Digital Barometric Pressure Sensor Module High Quality is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1050,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-ky-037-sound-sensor-module",
    "name": "KY-037 Sound Sensor Module",
    "categoryId": "sensors",
    "subCategoryId": "sound-voice",
    "shortDescription": "High quality KY-037 Sound Sensor Module for hobbyists and professionals.",
    "longDescription": "The KY-037 Sound Sensor Module is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 240,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1484755560695-a4c7300c5c29?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-light-sensor-ldr-3pin-photosensitive-sensor-module-light-dependent-control-lm393",
    "name": "Light Sensor (LDR)/ 3pin Photosensitive Sensor Module Light-Dependent Control LM393",
    "categoryId": "sensors",
    "subCategoryId": "optical-light",
    "shortDescription": "High quality Light Sensor (LDR)/ 3pin Photosensitive Sensor Module Light-Dependent Control LM393 for hobbyists and professionals.",
    "longDescription": "The Light Sensor (LDR)/ 3pin Photosensitive Sensor Module Light-Dependent Control LM393 is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 210,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1507646227500-4d389b0012be?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-sw1801p-4pin-normally-open-vibration-sensor-module-na479",
    "name": "SW1801P 4pin Normally Open Vibration Sensor Module (NA479)",
    "categoryId": "sensors",
    "subCategoryId": "motion-distance",
    "shortDescription": "High quality SW1801P 4pin Normally Open Vibration Sensor Module (NA479) for hobbyists and professionals.",
    "longDescription": "The SW1801P 4pin Normally Open Vibration Sensor Module (NA479) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 180,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1581092334651-ddf1a89a2440?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-max30100-pulse-oximeter-heart-rate-sensor-module-nb110",
    "name": "MAX30100 Pulse Oximeter Heart Rate Sensor Module (NB110)",
    "categoryId": "sensors",
    "subCategoryId": "temp-humidity",
    "shortDescription": "High quality MAX30100 Pulse Oximeter Heart Rate Sensor Module (NB110) for hobbyists and professionals.",
    "longDescription": "The MAX30100 Pulse Oximeter Heart Rate Sensor Module (NB110) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 400,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-esp32-c3-4m-development-board-with-soldering",
    "name": "ESP32-C3 4M Development Board with Soldering",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High quality ESP32-C3 4M Development Board with Soldering for hobbyists and professionals.",
    "longDescription": "The ESP32-C3 4M Development Board with Soldering is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1000,
    "stock": 15,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-esp32-wifi-bluetooth-development-board-ultra-low-power-dual-core-ch9102x-30pin-micro-na707",
    "name": "ESP32 WIFI Bluetooth Development Board Ultra-Low Power Dual Core (CH9102X + 30PIN + Micro) NA707",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High quality ESP32 WIFI Bluetooth Development Board Ultra-Low Power Dual Core (CH9102X + 30PIN + Micro) NA707 for hobbyists and professionals.",
    "longDescription": "The ESP32 WIFI Bluetooth Development Board Ultra-Low Power Dual Core (CH9102X + 30PIN + Micro) NA707 is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1510,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-arduino-uno-uno-r3-dip-board-with-logo-china-1602-chip",
    "name": "Arduino Uno / UNO R3 DIP Board with Logo, China 1602 Chip",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High quality Arduino Uno / UNO R3 DIP Board with Logo, China 1602 Chip for hobbyists and professionals.",
    "longDescription": "The Arduino Uno / UNO R3 DIP Board with Logo, China 1602 Chip is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1650,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-arduino-uno-r3-smd-board-improved-version-ch340-chip-aa744",
    "name": "Arduino Uno R3 SMD Board Improved Version CH340 Chip (AA744)",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High quality Arduino Uno R3 SMD Board Improved Version CH340 Chip (AA744) for hobbyists and professionals.",
    "longDescription": "The Arduino Uno R3 SMD Board Improved Version CH340 Chip (AA744) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1260,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-original-stm32f103c8t6-minimum-system-board-microcomputer-stm32-arm-core-board",
    "name": "Original STM32F103C8T6 Minimum System Board Microcomputer STM32 ARM Core Board",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High quality Original STM32F103C8T6 Minimum System Board Microcomputer STM32 ARM Core Board for hobbyists and professionals.",
    "longDescription": "The Original STM32F103C8T6 Minimum System Board Microcomputer STM32 ARM Core Board is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 760,
    "stock": 20,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-4-channel-low-level-relay-module-with-light-coupling-5v-aa026",
    "name": "4 Channel Low Level Relay Module with Light Coupling 5V (AA026)",
    "categoryId": "modules",
    "subCategoryId": "relays-switches",
    "shortDescription": "High quality 4 Channel Low Level Relay Module with Light Coupling 5V (AA026) for hobbyists and professionals.",
    "longDescription": "The 4 Channel Low Level Relay Module with Light Coupling 5V (AA026) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 610,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-6-channel-low-level-relay-module-with-light-coupling-5v-aa027",
    "name": "6 Channel Low Level Relay Module with Light Coupling 5V (AA027)",
    "categoryId": "modules",
    "subCategoryId": "relays-switches",
    "shortDescription": "High quality 6 Channel Low Level Relay Module with Light Coupling 5V (AA027) for hobbyists and professionals.",
    "longDescription": "The 6 Channel Low Level Relay Module with Light Coupling 5V (AA027) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1020,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-8-channel-low-level-relay-module-with-light-coupling-dc5v-aa028",
    "name": "8 Channel Low Level Relay Module with Light Coupling DC5V (AA028)",
    "categoryId": "modules",
    "subCategoryId": "relays-switches",
    "shortDescription": "High quality 8 Channel Low Level Relay Module with Light Coupling DC5V (AA028) for hobbyists and professionals.",
    "longDescription": "The 8 Channel Low Level Relay Module with Light Coupling DC5V (AA028) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1220,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-mt3608-2a-max-dc-dc-step-up-power-module-booster-power-module-aa180",
    "name": "MT3608 2A Max DC-DC Step Up Power Module Booster Power Module (AA180)",
    "categoryId": "modules",
    "subCategoryId": "power-modules",
    "shortDescription": "High quality MT3608 2A Max DC-DC Step Up Power Module Booster Power Module (AA180) for hobbyists and professionals.",
    "longDescription": "The MT3608 2A Max DC-DC Step Up Power Module Booster Power Module (AA180) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 190,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1620288627223-53302f4e8c74?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-xl4005-dc-dc-5-32v-adjustable-step-down-5a-buck-power-supply-module-aa579",
    "name": "XL4005 DC-DC 5-32V Adjustable Step Down 5A Buck Power Supply Module (AA579)",
    "categoryId": "modules",
    "subCategoryId": "power-modules",
    "shortDescription": "High quality XL4005 DC-DC 5-32V Adjustable Step Down 5A Buck Power Supply Module (AA579) for hobbyists and professionals.",
    "longDescription": "The XL4005 DC-DC 5-32V Adjustable Step Down 5A Buck Power Supply Module (AA579) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 440,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1620288627223-53302f4e8c74?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-tp4056-tc4056-1a-lipo-battery-charging-board-type-c-with-current-protection-aa477",
    "name": "TP4056 TC4056 1A Lipo Battery Charging Board Type-C with Current Protection (AA477)",
    "categoryId": "modules",
    "subCategoryId": "power-modules",
    "shortDescription": "High quality TP4056 TC4056 1A Lipo Battery Charging Board Type-C with Current Protection (AA477) for hobbyists and professionals.",
    "longDescription": "The TP4056 TC4056 1A Lipo Battery Charging Board Type-C with Current Protection (AA477) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 90,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1620288627223-53302f4e8c74?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-28byj-48-5v-4-phase-stepper-step-motor",
    "name": "28BYJ-48 5V 4-Phase Stepper Step Motor",
    "categoryId": "motors",
    "subCategoryId": "stepper-motors",
    "shortDescription": "High quality 28BYJ-48 5V 4-Phase Stepper Step Motor for hobbyists and professionals.",
    "longDescription": "The 28BYJ-48 5V 4-Phase Stepper Step Motor is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 480,
    "stock": 15,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-uln2003-driver-board-stepper-motor-green",
    "name": "ULN2003 Driver Board Stepper Motor Green",
    "categoryId": "motors",
    "subCategoryId": "stepper-motors",
    "shortDescription": "High quality ULN2003 Driver Board Stepper Motor Green for hobbyists and professionals.",
    "longDescription": "The ULN2003 Driver Board Stepper Motor Green is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 240,
    "stock": 15,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-mini-3pi-car-n20-caster-robot-ball-wheel-ad095",
    "name": "MINI 3PI Car N20 Caster Robot Ball Wheel (AD095)",
    "categoryId": "motors",
    "subCategoryId": "motor-drivers",
    "shortDescription": "High quality MINI 3PI Car N20 Caster Robot Ball Wheel (AD095) for hobbyists and professionals.",
    "longDescription": "The MINI 3PI Car N20 Caster Robot Ball Wheel (AD095) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 240,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1563770660941-20978e870e26?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-servo-sg90-9g-180-degree-1-6kg-torque-china-chip-aa213",
    "name": "Servo SG90 9g 180 Degree 1.6KG Torque (China Chip) (AA213)",
    "categoryId": "motors",
    "subCategoryId": "servo-motors",
    "shortDescription": "High quality Servo SG90 9g 180 Degree 1.6KG Torque (China Chip) (AA213) for hobbyists and professionals.",
    "longDescription": "The Servo SG90 9g 180 Degree 1.6KG Torque (China Chip) (AA213) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 440,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-high-power-robot-smart-car-motor-driver-bts7960-na105",
    "name": "High Power Robot Smart Car Motor Driver BTS7960 (NA105)",
    "categoryId": "motors",
    "subCategoryId": "motor-drivers",
    "shortDescription": "High quality High Power Robot Smart Car Motor Driver BTS7960 (NA105) for hobbyists and professionals.",
    "longDescription": "The High Power Robot Smart Car Motor Driver BTS7960 (NA105) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1220,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1563770660941-20978e870e26?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-diy-automatic-flower-watering-automatic-irrigation-module-soil-moisture-detection-type-b-ae152",
    "name": "DIY Automatic Flower Watering Automatic Irrigation Module Soil Moisture Detection Type B (AE152)",
    "categoryId": "sensors",
    "subCategoryId": "soil-water",
    "shortDescription": "High quality DIY Automatic Flower Watering Automatic Irrigation Module Soil Moisture Detection Type B (AE152) for hobbyists and professionals.",
    "longDescription": "The DIY Automatic Flower Watering Automatic Irrigation Module Soil Moisture Detection Type B (AE152) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1200,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-ky-040-rotary-encoder-module-for-arduino-with-demo-code",
    "name": "KY-040 Rotary Encoder Module for Arduino with Demo Code",
    "categoryId": "components",
    "subCategoryId": "switches",
    "shortDescription": "High quality KY-040 Rotary Encoder Module for Arduino with Demo Code for hobbyists and professionals.",
    "longDescription": "The KY-040 Rotary Encoder Module for Arduino with Demo Code is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 230,
    "stock": 23,
    "imageUrl": "https://images.unsplash.com/photo-1591405351990-4726e331f141?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0,
    "options": [
      {
        "name": "PPR",
        "values": ["100 PPR", "200 PPR", "500 PPR"]
      }
    ],
    "variants": [
      {
        "id": "prod-ky-040-rotary-encoder-module-for-arduino-with-demo-code-v-100ppr",
        "sku": "SZ-KY040-100PPR",
        "price": 230,
        "stock": 10,
        "options": {
          "PPR": "100 PPR"
        }
      },
      {
        "id": "prod-ky-040-rotary-encoder-module-for-arduino-with-demo-code-v-200ppr",
        "sku": "SZ-KY040-200PPR",
        "price": 350,
        "stock": 8,
        "options": {
          "PPR": "200 PPR"
        }
      },
      {
        "id": "prod-ky-040-rotary-encoder-module-for-arduino-with-demo-code-v-500ppr",
        "sku": "SZ-KY040-500PPR",
        "price": 580,
        "stock": 5,
        "options": {
          "PPR": "500 PPR"
        }
      }
    ]
  },
  {
    "id": "prod-neo-6m-gps-module-with-eeprom-for-c-aeroquad-with-antenna-gy-neo6mv2-with-battery-na058",
    "name": "NEO-6M GPS Module with EEPROM for C/AeroQuad with Antenna GY-NEO6MV2 (with Battery) (NA058)",
    "categoryId": "modules",
    "subCategoryId": "wireless-comm",
    "shortDescription": "High quality NEO-6M GPS Module with EEPROM for C/AeroQuad with Antenna GY-NEO6MV2 (with Battery) (NA058) for hobbyists and professionals.",
    "longDescription": "The NEO-6M GPS Module with EEPROM for C/AeroQuad with Antenna GY-NEO6MV2 (with Battery) (NA058) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 1290,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-lcd1602-yellow-green-backlight-5v-aa012",
    "name": "LCD1602 Yellow Green Backlight 5V (AA012)",
    "categoryId": "modules",
    "subCategoryId": "displays-hmi",
    "shortDescription": "High quality LCD1602 Yellow Green Backlight 5V (AA012) for hobbyists and professionals.",
    "longDescription": "The LCD1602 Yellow Green Backlight 5V (AA012) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 490,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-iic-i2c-pcf8574-serial-interface-adapter-module-aa134",
    "name": "IIC/I2C PCF8574 Serial Interface Adapter Module (AA134)",
    "categoryId": "modules",
    "subCategoryId": "displays-hmi",
    "shortDescription": "High quality IIC/I2C PCF8574 Serial Interface Adapter Module (AA134) for hobbyists and professionals.",
    "longDescription": "The IIC/I2C PCF8574 Serial Interface Adapter Module (AA134) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 200,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-mini-sd-card-module-size-18-5mm-x-17-5mm-aa440",
    "name": "Mini SD Card Module Size: 18.5mm x 17.5mm (AA440)",
    "categoryId": "modules",
    "subCategoryId": "wireless-comm",
    "shortDescription": "High quality Mini SD Card Module Size: 18.5mm x 17.5mm (AA440) for hobbyists and professionals.",
    "longDescription": "The Mini SD Card Module Size: 18.5mm x 17.5mm (AA440) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 190,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-max485-ttl-to-rs485-converter-module-aa119",
    "name": "MAX485 TTL to RS485 Converter Module (AA119)",
    "categoryId": "modules",
    "subCategoryId": "wireless-comm",
    "shortDescription": "High quality MAX485 TTL to RS485 Converter Module (AA119) for hobbyists and professionals.",
    "longDescription": "The MAX485 TTL to RS485 Converter Module (AA119) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 140,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-usb-logic-analyzer-24m-8ch-aa161",
    "name": "USB Logic Analyzer 24M 8CH (AA161)",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High quality USB Logic Analyzer 24M 8CH (AA161) for hobbyists and professionals.",
    "longDescription": "The USB Logic Analyzer 24M 8CH (AA161) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 2310,
    "stock": 5,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-solder-wire-0-8mm-50g",
    "name": "Solder Wire 0.8mm 50g",
    "categoryId": "tools",
    "subCategoryId": "soldering-gear",
    "shortDescription": "High quality Solder Wire 0.8mm 50g for hobbyists and professionals.",
    "longDescription": "The Solder Wire 0.8mm 50g is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 800,
    "stock": 15,
    "imageUrl": "https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-600-pcs-1-4w-1-30-kinds-resistor-assortment-kit-set-20x-each-value",
    "name": "600 Pcs 1/4W 1% 30 Kinds Resistor Assortment Kit Set (20x each value)",
    "categoryId": "components",
    "subCategoryId": "resistors-caps",
    "shortDescription": "High quality 600 Pcs 1/4W 1% 30 Kinds Resistor Assortment Kit Set (20x each value) for hobbyists and professionals.",
    "longDescription": "The 600 Pcs 1/4W 1% 30 Kinds Resistor Assortment Kit Set (20x each value) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 530,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1555664424-778a1e5e1b48?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-9x15cm-universal-pcb-prototype-board-single-sided-2-54mm-hole-pitch-nc439",
    "name": "9x15cm Universal PCB Prototype Board Single-Sided 2.54mm Hole Pitch (NC439)",
    "categoryId": "tools",
    "subCategoryId": "breadboards",
    "shortDescription": "High quality 9x15cm Universal PCB Prototype Board Single-Sided 2.54mm Hole Pitch (NC439) for hobbyists and professionals.",
    "longDescription": "The 9x15cm Universal PCB Prototype Board Single-Sided 2.54mm Hole Pitch (NC439) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 290,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1517059224940-d4af9eec41b7?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-4x6-cm-universal-pcb-prototype-board-double-sided-2-54mm-hole-pitch-nc046",
    "name": "4x6 cm Universal PCB Prototype Board Double-Sided 2.54mm Hole pitch (NC046)",
    "categoryId": "tools",
    "subCategoryId": "breadboards",
    "shortDescription": "High quality 4x6 cm Universal PCB Prototype Board Double-Sided 2.54mm Hole pitch (NC046) for hobbyists and professionals.",
    "longDescription": "The 4x6 cm Universal PCB Prototype Board Double-Sided 2.54mm Hole pitch (NC046) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 90,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1517059224940-d4af9eec41b7?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-soldering-iron-60w-220v-eu-plug-nc231",
    "name": "Soldering Iron 60W 220V EU Plug (NC231)",
    "categoryId": "tools",
    "subCategoryId": "soldering-gear",
    "shortDescription": "High quality Soldering Iron 60W 220V EU Plug (NC231) for hobbyists and professionals.",
    "longDescription": "The Soldering Iron 60W 220V EU Plug (NC231) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 700,
    "stock": 10,
    "imageUrl": "https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-858d-hot-air-soldering-station-with-display-uk-plug-nc604",
    "name": "858D Hot Air Soldering Station with Display UK Plug (NC604)",
    "categoryId": "tools",
    "subCategoryId": "soldering-gear",
    "shortDescription": "High quality 858D Hot Air Soldering Station with Display UK Plug (NC604) for hobbyists and professionals.",
    "longDescription": "The 858D Hot Air Soldering Station with Display UK Plug (NC604) is a reliable component designed for electronic prototyping, research and development. Ideal for Arduino, ESP32, Raspberry Pi, and other microcontroller systems.",
    "price": 18490,
    "stock": 1,
    "imageUrl": "https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Condition",
        "value": "New"
      },
      {
        "name": "Pack Size",
        "value": "1 Unit"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-esp32-s3-n16r8",
    "name": "Black Unsoldered ESP32-S3 WiFi BLE 5.0 Mesh Development Board N16R8",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "High-performance ESP32-S3 WiFi + BLE 5.0 development board with 16MB Flash and 8MB PSRAM.",
    "longDescription": "The ESP32-S3 is a dual-core XTensa LX7 MCU capable of running at 240 MHz. In addition to its 512 KB of internal SRAM, it comes with 16MB of Flash and 8MB of PSRAM. Includes WiFi and Bluetooth 5 (LE) connectivity.",
    "price": 2350,
    "stock": 25,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Flash",
        "value": "16MB (N16)"
      },
      {
        "name": "PSRAM",
        "value": "8MB (R8)"
      },
      {
        "name": "Core",
        "value": "Dual-Core 32-bit LX7"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-arduino-nano-ch340",
    "name": "Arduino Nano V3.0 CH340 Chip Board ATmega328P (Mini USB)",
    "categoryId": "modules",
    "subCategoryId": "dev-boards",
    "shortDescription": "Compact microcontroller board based on ATmega328P with CH340 USB-to-Serial converter.",
    "longDescription": "The Arduino Nano is a small, complete, and breadboard-friendly board based on the ATmega328P. It has more or less the same functionality of the Arduino Duemilanove, but in a different package. It lacks only a DC power jack, and works with a Mini-B USB cable instead of a standard one.",
    "price": 1020,
    "stock": 30,
    "imageUrl": "https://images.unsplash.com/photo-1608564697071-ddf911d81370?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Microcontroller",
        "value": "ATmega328P"
      },
      {
        "name": "USB chip",
        "value": "CH340"
      },
      {
        "name": "Operating Voltage",
        "value": "5V"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  },
  {
    "id": "prod-jumper-wire-mf-20cm",
    "name": "Jumper Wire Male to Female 20cm (40pcs Bundle)",
    "categoryId": "tools",
    "subCategoryId": "cables-wires",
    "shortDescription": "Ribbon of 40 individual male-to-female jumper cables, 20cm length.",
    "longDescription": "High quality flexible breadboard jumper wire ribbon cables with male-to-female pins. Ideal for circuit prototype connections between development boards and sensors.",
    "price": 200,
    "stock": 60,
    "imageUrl": "https://images.unsplash.com/photo-1551747582-8bc049f50e7b?auto=format&fit=crop&w=500&h=500&q=80",
    "specs": [
      {
        "name": "Type",
        "value": "Male to Female"
      },
      {
        "name": "Length",
        "value": "20cm"
      },
      {
        "name": "Wires",
        "value": "40 wires per bundle"
      }
    ],
    "rating": 5.0,
    "reviewsCount": 0
  }
];
